import { Phone, MapPin, Clock } from 'lucide-react';
import { SEO, track } from '@/lib/seo';
import { Reveal } from '@/lib/motion';
import { BUSINESS } from '@/data/site';
import ZipChecker from '@/components/ZipChecker';

export default function Contact() {
  return (
    <>
      <SEO
        title="Contact | Majestic Greens DMV — Washington, DC"
        description={`Contact Majestic Greens DMV at ${BUSINESS.phone} or visit us at ${BUSINESS.address}, ${BUSINESS.city}, ${BUSINESS.state} ${BUSINESS.zip}. Premium cannabis retail in downtown DC. Adults 21+.`}
        path="/contact"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'ContactPage',
          name: 'Contact Majestic Greens DMV',
          url: 'https://majesticgreensdmv.com/contact',
          about: { '@id': 'https://majesticgreensdmv.com/#business' },
          isPartOf: { '@id': 'https://majesticgreensdmv.com/#website' },
        }}
      />
      <div data-testid="contact-page" className="mx-auto max-w-5xl px-6 pb-28 pt-28">
        <Reveal>
          <p className="text-[11px] font-bold uppercase tracking-[0.4em] text-bronze">Get In Touch</p>
          <h1 className="mt-4 font-serif text-4xl text-ink sm:text-6xl">Contact us</h1>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-sage">
            Questions about the menu, your order, or whether we serve your address? The fastest way to reach us is a phone call — a real person will pick up.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-6 lg:grid-cols-2">
          <Reveal delay={0.1}>
            <a
              href={BUSINESS.phoneHref}
              data-testid="contact-phone-cta"
              onClick={() => track('phone_click', { source: 'contact_page' })}
              className="group flex h-full flex-col justify-between border border-gold/40 bg-gold/5 p-10 transition-colors hover:bg-gold/10"
            >
              <Phone className="h-8 w-8 text-bronze" />
              <div className="mt-10">
                <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-ash">Call us</p>
                <p className="mt-2 font-serif text-4xl text-ink transition-colors group-hover:text-bronze">{BUSINESS.phone}</p>
                <p className="mt-3 text-sm text-sage">Fastest response for orders, menu questions, and service-area checks.</p>
              </div>
            </a>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="flex h-full flex-col justify-between border border-ink/10 p-10">
              <MapPin className="h-8 w-8 text-bronze" />
              <div className="mt-10">
                <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-ash">Visit us</p>
                <address className="mt-2 font-serif text-2xl not-italic leading-snug text-ink">
                  {BUSINESS.name}<br />
                  {BUSINESS.address}<br />
                  {BUSINESS.city}, {BUSINESS.state} {BUSINESS.zip}
                </address>
                <p className="mt-3 flex items-center gap-2 text-sm text-sage">
                  <Clock className="h-4 w-4 text-bronze" /> {BUSINESS.hours}
                </p>
              </div>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.25}>
          <div className="mt-14 border border-ink/10 bg-surface p-10">
            <h2 className="font-serif text-2xl text-ink">Not sure if we serve your area?</h2>
            <p className="mt-2 text-sm text-sage">Check instantly — it takes five seconds.</p>
            <div className="mt-6"><ZipChecker /></div>
          </div>
        </Reveal>
      </div>
    </>
  );
}
